import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "inventory-view-mode"

export default class extends Controller {
  static targets = ["input", "item", "section", "compactBtn", "normalBtn"]
  static values = { mode: { type: String, default: "normal" } }

  connect() {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) this.modeValue = saved
    this.applyMode()
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach(item => {
      const text = (item.dataset.searchText || "").toLowerCase()
      const match = query.length === 0 || text.includes(query)
      item.classList.toggle("hidden", !match)
    })

    this.sectionTargets.forEach(section => {
      const hasVisible = Array.from(
        section.querySelectorAll("[data-inventory-filter-target='item']")
      ).some(el => !el.classList.contains("hidden"))
      section.classList.toggle("hidden", query.length > 0 && !hasVisible)
    })
  }

  setCompact() {
    this.modeValue = "compact"
    localStorage.setItem(STORAGE_KEY, "compact")
    this.applyMode()
  }

  setNormal() {
    this.modeValue = "normal"
    localStorage.setItem(STORAGE_KEY, "normal")
    this.applyMode()
  }

  applyMode() {
    const compact = this.modeValue === "compact"
    this.element.classList.toggle("inventory-compact", compact)
    if (this.hasCompactBtnTarget) {
      this.compactBtnTarget.classList.toggle("text-tavern-gold", compact)
      this.compactBtnTarget.classList.toggle("text-tavern-muted", !compact)
    }
    if (this.hasNormalBtnTarget) {
      this.normalBtnTarget.classList.toggle("text-tavern-gold", !compact)
      this.normalBtnTarget.classList.toggle("text-tavern-muted", compact)
    }
  }
}
